import Reveal, { MaskedLine } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, intro, children }) {
  return (
    <section className="bg-gradient-to-b from-navy-50 to-cream border-b border-navy-100/60" data-testid="page-hero">
      <div className="container-site py-16 md:py-24">
        {eyebrow && <p className="eyebrow" data-testid="page-hero-eyebrow">{eyebrow}</p>}
        <h1 className="mt-3 text-4xl sm:text-5xl tracking-tight max-w-3xl" data-testid="page-hero-title">
          <MaskedLine>{title}</MaskedLine>
        </h1>
        {intro && (
          <Reveal delay={0.15}>
            <p className="mt-6 text-lg text-mutedink leading-relaxed max-w-2xl" data-testid="page-hero-intro">{intro}</p>
          </Reveal>
        )}
        {children}
      </div>
    </section>
  );
}
